import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { api } from '@/lib/api';
import { ChatTeardropDots, SpeakerHigh } from '@phosphor-icons/react';

import { bubbleImageSrc } from '@/lib/bubbleImage';
const toneAccent = {
  urgent: 'border-bx-magenta/60 text-bx-magenta',
  restless: 'border-bx-legendary/60 text-bx-legendary',
  lonely: 'border-bx-cyan/60 text-bx-cyan',
  hyped: 'border-bx-volt/60 text-bx-volt',
  myth: 'border-bx-gold/60 text-bx-gold',
};

const speak = (text, name) => {
  if (!('speechSynthesis' in window)) return;
  window.speechSynthesis.cancel();
  const u = new SpeechSynthesisUtterance(text);
  const voices = window.speechSynthesis.getVoices();
  if (voices.length) {
    const idx = Array.from(name || '').reduce((a, c) => a + c.charCodeAt(0), 0) % voices.length;
    u.voice = voices[idx];
  }
  u.pitch = 1.05; u.rate = 0.98;
  window.speechSynthesis.speak(u);
};

const WhispersStrip = () => {
  const [list, setList] = useState([]);

  useEffect(() => {
    api.get('/whispers/today').then(({ data }) => setList(data.whispers || [])).catch(() => {});
  }, []);

  if (!list.length) return null;

  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-3 text-[10px] uppercase tracking-widest text-white/60">
        <ChatTeardropDots size={12} weight="fill" /> whispers today
      </div>
      <div className="flex gap-3 overflow-x-auto pb-2 snap-x">
        {list.map((w, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.07 }}
            className={`min-w-[260px] max-w-[300px] glass-hi rounded-2xl p-4 border ${toneAccent[w.tone] || 'border-white/10 text-white'} snap-start`}
            data-testid={`whisper-${i}`}
          >
            <div className="flex items-center gap-3">
              {bubbleImageSrc(w) ? (
                <img src={bubbleImageSrc(w)} alt={w.name}
                     className="h-10 w-10 rounded-full object-cover ring-1 ring-white/15" />
              ) : (
                <div className={`h-10 w-10 rounded-full bg-rar-${w.rarity || 'common'}`} />
              )}
              <div className="flex-1 min-w-0">
                <div className="text-[10px] uppercase tracking-widest text-white/60">{w.tone}</div>
                <div className="font-display font-bold truncate">{w.name}</div>
              </div>
              <button onClick={() => speak(w.text, w.name)} className="text-white/65 hover:text-white"
                      data-testid={`whisper-speak-${i}`} aria-label="speak">
                <SpeakerHigh size={16} weight="bold" />
              </button>
            </div>
            <div className="text-sm text-white/85 mt-2 italic leading-snug">"{w.text}"</div>
            {w.bubble_id && (
              <Link to={`/bubble/${w.bubble_id}`} className="mt-3 inline-flex text-xs text-bx-cyan font-bold"
                    data-testid={`whisper-open-${i}`}>
                go to {w.name} →
              </Link>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default WhispersStrip;
